export default __webpack_public_path__ + "static/media/Bridge.2e37a7b1.svg";